export default {"src":"/_next/static/media/carousel-icon-01.d9e07b96.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};